(function () {
  async function buyNow(btn) {
    var form = btn.closest('form');
    if (!form || btn.getAttribute('aria-disabled') === 'true') return;

    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');

    try {
      var res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      if (!res.ok) throw new Error(res.status);
      window.location.href = '/checkout';
    } catch (e) {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
      var alert = form.querySelector('.js-form-error');
      if (alert) {
        alert.textContent = 'Could not start checkout. Please try again.';
        alert.hidden = false;
      }
    }
  }

  // The Make an offer app injects its button next to Add to cart; the design puts it in the secondary row.
  function relocateOffer() {
    var alt = document.querySelector('[data-pdp-alt]');
    var offer = document.querySelector('.product-info__add-button .offerButton');
    if (alt && offer) alt.insertBefore(offer, alt.firstChild);
  }

  document.addEventListener('click', function (e) {
    var buy = e.target.closest('[data-buy-now]');
    if (buy) {
      e.preventDefault();
      buyNow(buy);
    }
  });

  function init() {
    relocateOffer();
    new MutationObserver(relocateOffer).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
